import React from "react";
import { Phone } from "lucide-react";
import { useSection } from "@/context/SiteContext";
import { telHref } from "@/lib/site";

export default function StickyMobileCTA() {
  const sticky = useSection("sticky_cta");
  const contact = useSection("contact");
  const tel = telHref(contact.phone_tel, contact.phone);
  const text = sticky.text || `Beställ nu · ${contact.phone || "0660-511 30"}`;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-white/95 backdrop-blur-md border-t border-[var(--border)]"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={tel}
        data-testid="sticky-mobile-order-button"
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[var(--primary)] hover:bg-[var(--primary-hover)] text-white py-4 font-bold shadow-lg shadow-[var(--primary)]/25 transition-colors"
      >
        <Phone size={17} /> {text}
      </a>
    </div>
  );
}
